import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-battery-full",
  "use": "icon-battery-full-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-battery-full\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-battery-full\">\r\n  <path fill-rule=\"evenodd\" d=\"M12 5H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM2 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2z\" />\r\n  <path d=\"M2 6h10v4H2V6zm12.5 3.5a1.5 1.5 0 0 0 0-3v3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/battery-full.svg
// module id = OTuz
// module chunks = 60